import styled from '@emotion/styled'

import { Media, type MediaProps } from '@/components/Media'
import { BodyM } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

export interface ListFeatureProps {
  title: {
    text: string
    tag?: string
  }
  description: string
  midia: MediaProps
  width?: number
  height?: number
}

const FeatureStyles = styled.div({
  /* container */
  display: 'flex',
  alignItems: 'center',
  marginBottom: 'var(--space-3)',

  '& .image': {
    position: 'relative',
    width: '5rem',
    marginRight: '1rem',
    borderRadius: 'var(--radii-default)',
    overflow: 'hidden',
  },

  [CONFIG.media.mobileLg]: {
    paddingRight: '0',
    '& .image': {
      width: '3rem',
    },
  },
})

const Feature = ({
  title,
  description,
  midia: medusaMidiaProps,
  width = 80,
  height = 80,
}: ListFeatureProps) => (
  <FeatureStyles>
    <div>
      <div className="image">
        <Media width={width} height={height} layout="responsive" {...medusaMidiaProps} />
      </div>
    </div>

    <div className="et-ta-left">
      <BodyM tag={title.tag || 'p'} dark="medium" className="eu-sm-1" emphasys>
        {title.text}
      </BodyM>

      {description && <BodyM tag="div" dark="medium" html={description} />}
    </div>
  </FeatureStyles>
)

export default Feature
